import { RootState } from '../../../../redux/store';
import { SavedPrompt } from '../../../chat/models/SavedPrompt';
import { selectChatPersonalizationState } from './selectChatPersonalizationState';

export const selectSavedPrompts = (state: RootState): SavedPrompt[] => {
    return selectChatPersonalizationState(state).prompts;
};
